import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, renderList as _renderList, createSlots as _createSlots } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(_component_v_autocomplete, _mergeProps(_ctx.$attrs, {
    search: _ctx.search,
    "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.search = ''))
  }), _createSlots({
    "no-data": _withCtx(() => [
      (_ctx.creatable && _ctx.search && _ctx.search.trim())
        ? (_openBlock(), _createBlock(_component_v_list_item, {
            key: 0,
            onClick: _ctx.create
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$tt('action.create-instance')) + " ", 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.search), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    _renderList(_ctx.forwardedSlots, (name) => {
      return {
        name: name,
        fn: _withCtx((scope) => [
          _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(scope || {})))
        ])
      }
    }),
    (_ctx.offersButton)
      ? {
          name: "append-inner",
          fn: _withCtx(() => [
            _createVNode(_component_v_btn, {
              icon: "",
              variant: "text",
              size: "small",
              density: "comfortable",
              title: _ctx.$tt('new'),
              onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              onClick: _withModifiers(_ctx.create, ["stop"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("mdi-plus", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title", "onClick"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1040, ["search"]))
}